import React from 'react';
import {TasksContent} from './styled';

type TaskListProps = {
  items: JSX.Element[] | string[];
};

function TaskList({items}: TaskListProps) {
  return (
    <TasksContent>
      {items.map((item, index) => (
        <li key={index}>
          <div>{item}</div>
        </li>
      ))}
    </TasksContent>
  );
}

export default TaskList;
